import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const SharedMessageBoards = props => (
    <SvgIcon {...props}>
        <path
            d="M10.215 6.964c.544 0 .986.432 1.002.972V13.975c0 .543-.433.986-.973 1.001H3.203L2.179 16H1.2l.004-8.035c0-.544.428-.986.968-1.001h8.043zm-1.001 5.008H3.203v1.001h6.01v-1.001zm0-1.503H3.203v1.002h6.01v-1.002zm0-1.502H3.203v1.001h6.01V8.967zM16.002.87v6.203l-.892-.893H9.674a.773.773 0 01-.746-.746V.747A.773.773 0 019.674 0h6.076c.16.252.252.55.252.87zm-.892 2.992h-4.637v.773h4.637v-.773zm0-1.159h-4.637v.773h4.637v-.773zm0-1.159h-4.637v.773h4.637v-.773z"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default SharedMessageBoards;
